(function () {
  const containers = document.querySelectorAll(".usage-tooltip-container");

  if (!containers.length) return;

  function closeAllTooltips() {
    containers.forEach((container) => {
      const trigger = container.querySelector(".usage-tooltip-trigger");
      const overlay = container.querySelector(".usage-tooltip-overlay");
      if (!trigger || !overlay) return;

      container.classList.remove("is-open");
      trigger.setAttribute("aria-expanded", "false");
      overlay.setAttribute("aria-hidden", "true");
    });
  }

  containers.forEach((container) => {
    const trigger = container.querySelector(".usage-tooltip-trigger");
    const overlay = container.querySelector(".usage-tooltip-overlay");

    if (!trigger || !overlay) return;

    let ignoreNextClick = false;

    function openTooltip() {
      closeAllTooltips();
      container.classList.add("is-open");
      trigger.setAttribute("aria-expanded", "true");
      overlay.setAttribute("aria-hidden", "false");
    }

    function closeTooltip() {
      container.classList.remove("is-open");
      trigger.setAttribute("aria-expanded", "false");
      overlay.setAttribute("aria-hidden", "true");
    }

    function handleToggleEvent(e) {
      const target = e.target;
      const isTouch = e.type === "touchend";

      if (
        !target.closest(".usage-tooltip-trigger") &&
        !target.closest(".usage-tooltip-label") &&
        !target.closest(".usage-tooltip-icon")
      ) {
        return;
      }

      if (isTouch) {
        e.preventDefault();
        ignoreNextClick = true;
      } else if (ignoreNextClick) {
        ignoreNextClick = false;
        return;
      }

      e.stopPropagation();

      if (container.classList.contains("is-open")) {
        closeTooltip();
      } else {
        openTooltip();
      }
    }

    // Delegate taps/clicks on label, icon, or trigger to toggle the tooltip
    container.addEventListener("click", handleToggleEvent);
    container.addEventListener("touchend", handleToggleEvent);
  });

  // Close when clicking outside any container
  document.addEventListener("click", function (e) {
    const clickedInside = Array.from(containers).some((container) =>
      container.contains(e.target)
    );

    if (!clickedInside) {
      closeAllTooltips();
    }
  });

  // Optional: close all with Escape key
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      closeAllTooltips();
    }
  });
})();



